import { AxiosInstance } from 'axios'
import { BaseListParams, PaginatedResponse } from '../base.type'
import { Catalog, CatalogCreate, CatalogUpdate } from '../categories/catalog.type'

export class AreaApi {
    constructor(private readonly client: AxiosInstance) {}

    /**
     * Get all departments with pagination
     */
    async list(
        params?: BaseListParams & {
            regionIds?: string | null | undefined
        },
    ): Promise<PaginatedResponse<Catalog>> {
        const response = await this.client.get<PaginatedResponse<Catalog>>('/areas', {
            params,
        })
        return response.data
    }

    /**
     * Get a single area by ID
     */
    async findOne(id: string): Promise<Catalog> {
        const response = await this.client.get<Catalog>(`/areas/${id}`)
        return response.data
    }

    /**
     * Create a new department
     */
    async create(payload: CatalogCreate): Promise<Catalog> {
        const response = await this.client.post<Catalog>('/areas', payload)
        return response.data
    }

    /**
     * Update a department
     */
    async update(id: string, payload: CatalogUpdate): Promise<Catalog> {
        const response = await this.client.put<Catalog>(`/areas/${id}`, payload)
        return response.data
    }

    /**
     * Delete a department
     */
    async delete(id: string): Promise<void> {
        await this.client.delete(`/areas/${id}`)
    }
}
